import { RgbColorType, RgbObject } from '../../models';

export function convertRgbToHex(rgb: RgbObject | RgbColorType): string {
  let red: number;
  let green: number;
  let blue: number;

  switch (typeof rgb) {
    case 'string': {
      const matches = rgb.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);

      if (!matches) {
        throw new Error('Invalid RGB string format');
      }

      red = +matches[1];
      green = +matches[2];
      blue = +matches[3];
      break;
    }
    case 'object': {
      ({ red, green, blue } = rgb);

      if ([red, green, blue].some((num) => typeof num !== 'number')) {
        throw new Error('Invalid RGB object values');
      }

      break;
    }
  }

  const toHex = (value: number): string => {
    const hex = value.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };

  return `#${toHex(red)}${toHex(green)}${toHex(blue)}`;
}
